var BillingCard = /** @class */ (function () {
    function BillingCard() {
    }
    Object.defineProperty(BillingCard.prototype, "id", {
        /**
         * Getter id
         * @return {string}
         */
        get: function () {
            return this._id;
        },
        /**
         * Setter id
         * @param {string} value
         */
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingCard.prototype, "brand", {
        /**
         * Getter brand
         * @return {string}
         */
        get: function () {
            return this._brand;
        },
        /**
         * Setter brand
         * @param {string} value
         */
        set: function (value) {
            this._brand = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingCard.prototype, "last4", {
        /**
         * Getter last4
         * @return {string}
         */
        get: function () {
            return this._last4;
        },
        /**
         * Setter last4
         * @param {string} value
         */
        set: function (value) {
            this._last4 = value;
        },
        enumerable: true,
        configurable: true
    });
    return BillingCard;
}());
export { BillingCard };



// WEBPACK FOOTER //
// ./src/app/shared/models/billing-card.ts.pre-build-optimizer.js